import { VehicleModel }                 from '../../app-lite/vehicles/models/vehicle';
import { VehicleRegistrationTireModel } from './models/vehicle-registration.tire';

interface VehicleRegistrationTireDetailsScope extends ng.IScope {
  tire   : VehicleRegistrationTireModel;
  vehicle: VehicleModel;
};

export function VehicleRegistrationTireDetailsCtrl (
  $scope : VehicleRegistrationTireDetailsScope,
  tire   : VehicleRegistrationTireModel,
  vehicle: VehicleModel
) {
  $scope.tire    = tire;
  $scope.vehicle = vehicle;
};
